var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F9F4C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2352 9.82552C12.2545 9.70656 11.3606 10.4049 11.2387 11.3854L11.0591 12.8304H12.0423L12.2074 11.5028C12.2628 11.0572 12.6691 10.7398 13.1149 10.7938L21.3118 11.788C21.7576 11.8421 22.0741 12.2472 22.0187 12.6928L21.3483 18.086C21.2929 18.5316 20.8866 18.8491 20.4408 18.795L20.0284 18.745V19.5644C20.0284 19.6194 20.025 19.6735 20.0184 19.7267L20.3204 19.7633C21.3012 19.8823 22.1951 19.1839 22.317 18.2035L22.9874 12.8103C23.1092 11.8299 22.4129 10.9386 21.4321 10.8197L13.2352 9.82552Z",
    fill: "#2B323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 13.7822C9 13.0636 9.58248 12.4811 10.301 12.4811H18.5601C19.2787 12.4811 19.8612 13.0636 19.8612 13.7822V19.8847C19.8612 20.6033 19.2787 21.1858 18.5601 21.1858H10.301C9.58249 21.1858 9 20.6033 9 19.8847V13.7822Z",
    stroke: "#2B323B",
    strokeWidth: 0.975761
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.4409L11.2109 16.7932C11.703 16.4264 12.3845 16.4535 12.846 16.8582L14.3773 18.2007C14.8113 18.5813 15.4442 18.6304 15.9317 18.3212L19.8612 15.8295",
    stroke: "#2B323B",
    strokeWidth: 0.975761,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7231 15.1597C16.7231 15.6604 16.3101 16.0761 15.7883 16.0761C15.2665 16.0761 14.8535 15.6604 14.8535 15.1597C14.8535 14.6591 15.2665 14.2434 15.7883 14.2434C16.3101 14.2434 16.7231 14.6591 16.7231 15.1597Z",
    stroke: "#2B323B",
    strokeWidth: 0.845659
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePicker);
export default __webpack_public_path__ + "static/media/imagePicker.b5fd1ab36d6b90a10d38659f428d2fb0.svg";
export { ForwardRef as ReactComponent };